// export default CarPickupLocation;
import React, { useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

const generateTimeList = (checkInDate) => {
  const timeList = [];
  if (checkInDate) {
    const checkInDateTime = new Date(checkInDate);

    if (checkInDateTime.getDate() === new Date().getDate()) {
      const now = new Date();
      let currentHour = now.getHours() + 4; // Start from 4 hours after the current time
      let currentMinute = now.getMinutes();
      // If minutes are non-zero, round up to the next 30-minute mark
      if (currentMinute > 0 && currentMinute < 30) {
        currentMinute = 30;
      } else if (currentMinute > 30) {
        currentMinute = 0;
        currentHour++;
      }

      // Ensure the hour is within a valid range (less than 24)
      if (currentHour >= 24) {
        currentHour -= 24;
      }


      for (let hour = currentHour; hour < 24; hour++) {
        for (let minute = currentMinute; minute < 60; minute += 30) {
          let formattedHour = hour % 12 || 12;
          const suffix = hour >= 12 ? "PM" : "AM";
          formattedHour = formattedHour.toString().padStart(2, "0");
          const formattedMinute = minute.toString().padStart(2, "0");
          timeList.push(`${formattedHour}:${formattedMinute} ${suffix}`);
        }
        currentMinute = 0;
      }
      return timeList;
    } else {

      // Loop through hours from 0 to 23 (representing 12 AM to 11 PM)
      for (let hour = 0; hour <= 23; hour++) {
        // Loop through minutes from 0 to 59
        for (let minute = 0; minute < 60; minute += 30) {
          let formattedHour = hour % 12 || 12; // Convert hour to 12-hour format
          const suffix = hour >= 12 ? "PM" : "AM"; // Determine AM/PM suffix
          formattedHour = formattedHour.toString().padStart(2, "0"); // Pad hour with leading zero if necessary
          const formattedMinute = minute.toString().padStart(2, "0"); // Pad minute with leading zero if necessary
          timeList.push(`${formattedHour}:${formattedMinute} ${suffix}`); // Format time and push to timeList
        }
      }

      return timeList;
    }
  }

  return timeList;
};

const CarPickupLocation = ({
  setTimeValue,
  timeValue,
  checkInDate,
  currentTime,
  error,
  helperText,
}) => {
  const timeList = generateTimeList(checkInDate);

  const handleAutocompleteChange = (event, value) => {
    setTimeValue(value);
  };

  return (
    <>
      <Box
        className={`searchMenu-loc lg:px-0 js-form-dd`}
        sx={{
          width: "100%",
          "& label.Mui-focused": {
            color: "black",
          },
          "& .MuiInputBase-input": {
            // height: "16px",
          },
          "& .MuiAutocomplete-clearIndicator": {
            display: "none", // Hides the clear (close) button
          },

          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
          "& .MuiInput-underline:after": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
              borderRadius: "8px",
            },
            "&:hover fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
            },
            "&.Mui-focused fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
            },
          },
        }}
      >
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          value={timeValue}
          options={timeList}
          onChange={handleAutocompleteChange}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Pickup Time"
              InputProps={{
                ...params.InputProps,
                style: error ? { borderColor: "red" } : {},
              }}
              error={error}
              helperText={helperText}
            />
          )}
        />
      </Box>
    </>
  );
};

export default CarPickupLocation;
